/* #77: PDP h2s fit one line on mobile — shrink only when needed (floor 62%).
   #189: cap the heading at its container's width while measuring — inside a flex column with
   items-start the h2 box grows to its own nowrap width, so scrollWidth never exceeded clientWidth,
   the shrink never ran and the nowrap stayed (stats heading widened every device PDP at 375). */
class FitH2 extends HTMLElement {}
const FLOOR = 0.62, MAXW = 1023;
function fit() {
  document.querySelectorAll('h2').forEach((el) => {
    el.style.fontSize = ''; el.style.whiteSpace = ''; el.style.maxWidth = '';
    if (window.innerWidth > MAXW) return;
    const base = parseFloat(getComputedStyle(el).fontSize);
    el.style.whiteSpace = 'nowrap'; el.style.maxWidth = '100%';
    let size = base;
    while (el.clientWidth && el.scrollWidth > el.clientWidth && size > base * FLOOR) {
      size -= 0.5;
      el.style.fontSize = size + 'px';
    }
    if (!el.clientWidth || el.scrollWidth > el.clientWidth) { el.style.whiteSpace = ''; el.style.fontSize = ''; el.style.maxWidth = ''; }
  });
}
let t;
addEventListener('resize', () => { clearTimeout(t); t = setTimeout(fit, 150); });
if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
fit();
